var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"max-w-[1290px] w-full mx-auto flex justify-between items-center p-8"},[_c('Logo'),_vm._v(" "),_c('NavItems',{attrs:{"navItems":_vm.navItems}}),_vm._v(" "),_c('NavRight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }